import { FireCMSTranslations } from "../types/translations";

/**
 * Portuguese (pt) translations for @firecms/core.
 *
 * @group Core
 */
export const pt: FireCMSTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Guardar",
    create: "Criar",
    create_copy: "Criar cópia",
    save_and_close: "Guardar e fechar",
    create_copy_and_close: "Criar cópia e fechar",
    create_and_close: "Criar e fechar",
    discard: "Descartar",
    clear: "Limpar",
    cancel: "Cancelar",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Editar",
    copy: "Copiar",
    delete: "Eliminar",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Eliminar?",
    delete_confirmation_body: "Esta ação eliminará a entidade. Tem a certeza?",
    delete_multiple_confirmation_body: "Esta ação eliminará as entidades selecionadas. Tem a certeza?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Alterações não guardadas",
    unsaved_changes_body: "Tem alterações não guardadas. Deseja descartá-las?",
    discard_changes: "Descartar alterações",
    keep_editing: "Continuar a editar",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Pesquisar",
    find_by_id: "Encontrar por ID",
    find_entity_by_id: "Encontrar entidade por ID",
    filter: "Filtrar",
    filters: "Filtros",
    clear_filter: "Limpar filtro",
    clear_filter_sort: "Limpar filtro/ordenação",
    clear_sort: "Limpar ordenação",
    no_items: "Sem itens",
    no_entries_found: "Nenhum registo encontrado",
    all_entries_loaded: "Todos os {{count}} registos carregados",
    create_your_first_entry: "Crie o seu primeiro registo",
    no_results_filter_sort: "Sem resultados com o filtro/ordenação aplicado",
    add: "Adicionar",
    remove: "Remover",
    multiple_entities: "Múltiplas entidades",
    unsaved_changes: "Tem alterações não guardadas em {{collectionName}}.",
    so_empty: "Tão vazio...",
    no_results: "Sem resultados com o filtro/ordenação aplicado",
    refresh_data: "Atualizar dados",
    dark_mode: "Escuro",
    light_mode: "Claro",
    system_mode: "Sistema",
    ok: "Ok",
    save_collection_config: "Guardar estrutura da coleção",
    search_for_more_icons: "Pesquisar mais ícones…",
    ai_modified: "Modificado por IA",
    size_label: "Tamanho",
    group_by: "Agrupar por",
    initialize_kanban_order: "Inicializar Ordem Kanban",
    copy_id: "Copiar ID",
    add_specific: "Adicionar {{name}}",
    select_specific: "Selecionar {{name}}",
    select_from: "Selecionar de {{name}}",
    done: "Concluído",
    log_out: "Terminar sessão",
    license_needed: "Licença necessária",
    license_description: "Precisa de uma licença válida para usar o FireCMS PRO. Por favor contacte {{email}} para mais informações.",
    column_cannot_be_edited: "Esta coluna não pode ser editada diretamente",
    close: "Fechar",
    unsaved_local_changes: "Alterações locais não guardadas",
    unsaved_local_changes_description: "Este documento foi editado localmente e tem alterações não guardadas. Estas alterações locais serão perdidas se não as aplicar.",
    preview_changes: "Pré-visualizar alterações",
    apply_changes: "Aplicar alterações",
    discard_local_changes: "Descartar alterações locais",
    preview_local_changes: "Pré-visualizar alterações locais",
    preview_local_changes_description: "Estas são as alterações locais que serão aplicadas ao formulário.",
    type: "Tipo",
    string: "string",
    number: "número",
    boolean: "booleano",
    date: "data",
    map: "mapa",
    array: "lista",
    arrays_of_arrays_not_supported: "Listas de listas não são suportadas.",
    data_type_not_supported: "Tipo de dados {{dataType}} ainda não suportado",
    passkey_error_unsupported: "O seu dispositivo ou browser não suporta passkeys.",

    admin: "Administrador",
    home: "Início",
    this_form_has_errors: "Este formulário tem erros",
    error_loading_navigation: "Erro ao carregar navegação",
    error_loading_auth: "Erro ao carregar autenticação",
    this_form_has_been_modified: "Este formulário foi modificado",
    current_form_in_sync: "O formulário atual está sincronizado com a base de dados",
    open_in_console: "Abrir na consola",
    collection_does_not_exist: "A coleção especificada não existe. Verifique a consola",
    unexpected_value: "Valor inesperado",
    unexpected_value_click_to_edit: "Valor inesperado. Clique para editar",
    unexpected_reference_value: "Valor de referência inesperado. Clique para editar",
    copy_url_to_clipboard: "Copiar URL para a área de transferência",
    open_image_in_new_tab: "Abrir imagem numa nova aba",
    reference_not_set: "Referência não definida",
    reference_does_not_exist: "A referência não existe",
    entity_not_found: "Entidade não encontrada",
    file_not_found: "Ficheiro não encontrado",
    unsaved_changes_in_entity: "Tem alterações não guardadas nesta entidade.",
    delete_this_role: "Eliminar esta função",
    no_roles_yet: "Ainda não tem nenhuma função.",
    create_default_roles: "Criar funções predefinidas",
    delete_role_confirmation: "Tem a certeza de que quer eliminar esta função?",
    delete_this_user: "Eliminar este utilizador",
    no_users_yet: "Ainda não existem utilizadores",
    add_logged_user_as_admin: "Adicionar o utilizador com sessão iniciada como administrador",
    add_current_user_as_admin: "Adicionar utilizador atual como administrador",
    create_default_roles_and_add_admin: "Criar funções predefinidas e adicionar utilizador atual como administrador",
    delete_user_confirmation: "Tem a certeza de que quer eliminar este utilizador?",
    create_your_users_and_roles: "Crie os seus utilizadores e funções",
    no_users_or_roles_defined: "Não tem utilizadores ou funções definidas. Pode criar funções predefinidas e adicionar o utilizador atual como administrador.",
    save_before_changing_schema: "Precisa de guardar o documento antes de alterar o esquema",
    edit_schema_for_this_form: "Editar esquema para este formulário",
    no_permissions_to_edit_collection: "Não tem permissões para editar esta coleção",
    browser_does_not_support_audio: "O seu browser não suporta o elemento de áudio.",
    user_not_found: "Utilizador não encontrado: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Eliminar",
    cannot_delete_selected: "Selecionou pelo menos uma entidade que não pode eliminar",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Adicionar",
    add_on_top: "Adicionar no topo",
    add_below: "Adicionar abaixo",
    add_to_field: "Adicionar a {{fieldName}}",
    value: "Valor",
    key: "Chave",
    drag_drop_multiple: "Arraste e solte ficheiros aqui, ou clique para selecionar. Arraste para reordenar.",
    drag_drop_single: "Arraste e solte um ficheiro aqui, ou clique para selecionar um",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Abrir menu",
    close_drawer: "Fechar painel lateral",
    navigation_drawer: "Painel lateral de navegação",

    // ─── Error states ─────────────────────────────────────────────
    error: "Erro",
    error_uploading_file: "Erro ao carregar ficheiro",
    error_deleting: "Erro ao eliminar",
    error_before_delete: "Erro antes de eliminar",
    error_updating_asset: "Erro ao atualizar recurso",
    error_deleting_asset: "Erro ao eliminar recurso",
    error_firestore_index: "É necessário um índice Firestore para esta consulta.",
    create_index: "Criar índice",
    value_is_not_reference: "O valor não é uma referência.",
    click_to_edit: "Clique para editar",
    data_is_not_array_of_references: "Os dados não são uma lista de referências",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "A carregar",
    local_changes_applied: "Alterações locais aplicadas ao formulário",
    local_changes_discarded: "Alterações locais descartadas",
    are_you_sure_leave: "Tem a certeza de que quer sair desta página?",
    see_console_details: "Consulte a consola para mais detalhes.",
    drop_here_create_group: "Solte aqui para criar um novo grupo",
    filter_for_null_values: "Filtrar valores nulos",
    value_updated_elsewhere: "Este valor foi atualizado noutro local",
    add_property: "Adicionar propriedade",
    edit_name: "Editar {{name}}",
    this_entity_not_exist: "Esta entidade não existe na base de dados",
    internal_error: "ERRO interno",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Renomear Grupo",
    group_name_label: "Nome do Grupo",
    group_name_empty_error: "O nome do grupo não pode estar vazio.",
    group_name_exists_error: "Este nome de grupo já existe.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Pesquisar coleções",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Visualizações",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Precisa de guardar a sua entidade antes de adicionar coleções adicionais",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Página não encontrada",
    page_not_found_body: "Esta página não existe ou pode não ter acesso a ela",
    back_to_home: "Voltar ao início",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Vista de coleção predefinida",
    table_view: "Tabela",
    cards_view: "Cartões",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Escolha como as entidades devem ser exibidas por padrão",

    document_view: "Vista de documento",
    side_panel: "Painel lateral",
    full_screen: "Ecrã inteiro",
    should_documents_opened_full_screen: "Os documentos devem ser abertos em ecrã inteiro ou num painel lateral inline",

    select_custom_view: "Selecionar vista personalizada",
    no_custom_views_defined: "Nenhuma vista personalizada definida. Defina as suas vistas personalizadas nas definições de personalização, antes de usar este diálogo.",

    select_custom_action: "Selecionar ação personalizada",
    no_custom_actions_defined: "Nenhuma ação personalizada definida. Defina as suas ações personalizadas nas definições de personalização, antes de usar este diálogo.",

    no_collections_found: "Nenhuma coleção encontrada",
    start_building_collections: "Comece a criar coleções no FireCMS facilmente. Mapeie-as aos dados existentes na sua base de dados, importe de ficheiros ou use os nossos modelos.",
    create_first_collection: "Crie a sua primeira coleção",
    define_collections_programmatically: "Também pode definir coleções programaticamente.",
    edit_collection: "Editar coleção",
    no_permissions_edit_collection: "Não tem permissões para editar esta coleção",
    no_permissions_create_collection: "Não tem permissões para criar coleções",
    create_collection: "Criar coleção",
    update_collection: "Atualizar coleção",

    new_collection: "Nova coleção",
    add_new_collection: "Adicionar nova coleção",
    collection_with_name: "Coleção {{name}}",
    change_icon: "Alterar ícone",
    is_subcollection_of: "Esta é uma subcoleção de",
    name: "Nome",
    collection_name_description: "Nome desta coleção, normalmente um nome no plural (ex. Produtos)",
    path: "Caminho",
    relative_path_to_parent: "Caminho relativo ao pai (não é necessário incluir o caminho do pai)",
    path_in_database: "Caminho em que esta coleção está armazenada na base de dados",
    singular_name: "Nome singular",
    singular_name_description: "Opcionalmente defina um nome singular para as suas entidades",
    description: "Descrição",
    description_of_collection: "Descrição da coleção, pode usar markdown",
    collection_id: "ID da coleção",
    collection_id_description: "Este ID identifica esta coleção. Normalmente igual ao caminho.",
    collection_group: "Grupo de coleções",
    collection_group_description: "Um grupo de coleções consiste em todas as coleções com o mesmo caminho. Isto permite consultar várias coleções ao mesmo tempo.",
    advanced_settings: "Definições avançadas",
    doc_history_global: "Revisões do histórico do documento ativadas se ativadas globalmente",
    doc_history_enabled: "Revisões do histórico do documento ATIVADAS",
    doc_history_not_enabled: "Revisões do histórico do documento NÃO ativadas",
    doc_history_description: "Quando ativado, cada documento nesta coleção terá um histórico de alterações. Útil para fins de auditoria. Os dados são armazenados numa subcoleção do documento na sua base de dados, chamada __history.",
    document_id_generation: "Geração de IDs de documentos",
    code_defined: "Definido por código",
    users_must_define_id: "Os utilizadores devem definir um ID",
    users_can_define_id: "Os utilizadores podem definir um ID, mas não é obrigatório",
    doc_id_auto_generated: "O ID do documento é gerado automaticamente",
    config_doc_id_generation: "Configure como os IDs de documentos são gerados ao criar novas entidades.",
    enable_text_search: "Ativar pesquisa de texto para esta coleção",
    text_search_description: "Permitir pesquisa de texto para esta coleção. Se não especificou um delegado de pesquisa de texto, será usada a pesquisa de texto local integrada. Não recomendado para grandes coleções, pois pode causar problemas de desempenho e custo.",
    database_id: "ID da base de dados",
    default_text: "(predefinição)",

    custom_actions: "Ações personalizadas",
    more_info: "Mais informações",
    define_custom_actions_cli: "Defina as suas próprias ações personalizadas carregando-as com o CLI.",
    action_defined_in_code: "Esta ação está definida em código com a chave",
    add_custom_entity_action: "Adicionar ação de entidade personalizada",
    remove_this_action: "Remover esta ação?",
    remove_action_warning: "Isto não eliminará nenhum dado, apenas a ação no CMS",

    subcollections_of: "Subcoleções de",
    add_subcollection: "Adicionar subcoleção",
    custom_views: "Vistas personalizadas",
    define_custom_views_cli: "Defina as suas próprias vistas personalizadas carregando-as com o CLI.",
    view_defined_in_code: "Esta vista está definida em código com a chave",
    add_custom_entity_view: "Adicionar vista de entidade personalizada",
    delete_this_subcollection: "Eliminar esta subcoleção?",
    remove_collection_warning: "Isto não eliminará nenhum dado, apenas a coleção no CMS",
    remove_this_view: "Remover esta vista?",
    remove_view_warning: "Isto não eliminará nenhum dado, apenas a vista no CMS",

    no_collection_selected: "Nenhuma coleção selecionada",
    code_for_collection: "Código para",
    use_config_define_json: "Use esta configuração para definir a coleção em formato JSON.",
    customise_collection_code: "Se quiser personalizar a coleção em código, pode adicionar este código de coleção à configuração da sua aplicação CMS.",
    copied: "Copiado",

    property_cant_be_edited: "Esta propriedade não pode ser editada",
    property_not_editable_description: "Pode não ter permissão para editá-la ou está definida em código com o sinalizador editável definido como falso.",
    delete_this_property: "Eliminar esta propriedade?",
    delete_property_warning: "Isto não eliminará nenhum dado, apenas modificará a coleção.",
    error_must_specify_id: "Deve especificar um id para o campo",
    error_id_format: "O id só pode conter letras, números e underscores (_), e não pode começar com um número",
    error_id_already_exists: "Já existe outro campo com este ID",
    error_must_specify_title: "Deve especificar um título para o campo",
    custom_or_other: "Personalizado/Outro",
    select_property_widget: "Selecionar um widget de propriedade",
    error_changing_data_type: "Este widget usa um tipo de dados diferente do widget inicialmente selecionado. Isto pode causar erros com dados existentes.",
    required: "Obrigatório",

    enum_form_dialog: "Diálogo de formulário enum",
    imported_data_preview: "Pré-visualização de dados importados",
    entities_with_same_id_overwritten: "Entidades com o mesmo id serão substituídas",
    collection_editor: "Editor de coleção",
    properties_in_this_group: "Propriedades neste grupo",
    data_property_mapping: "Mapeamento de propriedade de dados",
    property_edit_view: "Vista de edição de propriedade",
    all_of_these: "Todos estes",
    any_of_these: "Qualquer um destes",

    only_admins_edit_roles: "Apenas administradores podem editar funções",
    error_user_not_found: "Utilizador não encontrado",
    role: "Função",
    name_of_this_role: "Nome desta função",
    id_of_this_role: "ID desta função",
    create_entities: "Criar entidades",
    read_entities: "Ler entidades",
    update_entities: "Atualizar entidades",
    delete_entities: "Eliminar entidades",
    all_collections: "Todas as coleções",
    create_entities_in_collections: "Criar entidades em coleções",
    access_all_data_in_every_collection: "Aceder a todos os dados em todas as coleções",
    update_data_in_any_collection: "Atualizar dados em qualquer coleção",
    delete_data_in_any_collection: "Eliminar dados em qualquer coleção",
    allow_all_permissions_in_this_collections: "Permitir todas as permissões nestas coleções",
    all: "Todos",
    customise_permissions_description: "Pode personalizar as permissões que os utilizadores relacionados com esta função podem realizar nas entidades de cada coleção",
    create_collections: "Criar coleções",
    yes: "Sim",
    no: "Não",
    can_user_create_collections: "O utilizador pode criar coleções",
    edit_collections: "Editar coleções",
    only_own_collections: "Apenas as suas próprias",
    own: "Próprias",
    can_user_edit_collections: "O utilizador pode editar coleções",
    delete_collections: "Eliminar coleções",
    can_user_delete_collections: "O utilizador pode eliminar coleções",
    error_saving_role: "Ocorreu um erro ao guardar esta função",
    create_role: "Criar função",
    update: "Atualizar",

    only_admins_change_roles: "Apenas administradores podem alterar funções",
    must_be_at_least_one_admin: "Deve existir pelo menos um administrador",
    logged_user_not_found: "Utilizador com sessão iniciada não encontrado",
    user: "Utilizador",
    user_id: "ID do utilizador",
    name_of_this_user: "Nome deste utilizador",
    email_of_this_user: "Email deste utilizador",
    roles: "Funções",
    create_user: "Criar utilizador",

    users: "Utilizadores",
    add_user: "Adicionar utilizador",
    add_role: "Adicionar função",
    is_admin: "É Administrador",
    default_permissions: "Permissões predefinidas",
    created_on: "Criado em",
    email: "Email",
    id: "ID",
    read: "Ler",

    column_in_file: "Coluna no ficheiro",
    map_to_property: "Mapear para propriedade",
    default_values: "Valores predefinidos",
    default_values_description: "Pode selecionar um valor predefinido para colunas não mapeadas e valores vazios:",
    property: "Propriedade",
    default_value: "Valor predefinido",
    autogenerate_id: "Gerar ID automaticamente",
    id_column_description: "Coluna que será usada como ID para cada documento",
    do_not_set_value: "Não definir valor",
    set_value_to_true: "Definir valor como verdadeiro",
    set_value_to_false: "Definir valor como falso",
    drag_and_drop_file: "Arraste e solte um ficheiro aqui ou clique para carregar",
    error_saving_data: "Erro ao guardar dados",
    retry: "Tentar novamente",
    saving_data: "A guardar dados",
    entities_saved: "entidades guardadas",
    do_not_close_tab: "Não feche este separador ou a importação será interrompida",
    import: "Importar",
    import_data: "Importar dados",
    upload_file_description: "Carregue um ficheiro CSV, Excel ou JSON e mapeie-o para o esquema existente",
    back: "Voltar",
    next: "Seguinte",
    save_data: "Guardar dados",
    use_column_as_id: "Usar esta coluna como ID",
    do_not_import_property: "Não importar esta propriedade",
    entities_will_be_overwritten: "Entidades com o mesmo id serão substituídas",
    data_imported_successfully: "Dados importados com sucesso",
    export: "Exportar",
    export_data: "Exportar dados",
    download_table_csv: "Descarregar o conteúdo desta tabela como CSV",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Datas como timestamps",
    dates_as_strings: "Datas como strings",
    flatten_arrays: "Achatar listas",
    download: "Descarregar",
    large_number_of_documents: "Esta coleção tem um grande número de documentos ({{count}}).",
    include_undefined_values: "Incluir valores indefinidos",
    submit: "Submeter",

    no_filterable_properties: "Não há propriedades filtráveis disponíveis",
    apply_filters: "Aplicar filtros",
    list: "Lista",
    cards: "Cartões",
    board: "Quadro",
    initialize_kanban_order_desc: "Isto atribuirá valores de ordem sequenciais a todos os itens que não tenham um. Os itens manterão a sua ordem atual dentro de cada coluna.",
    kanban_view_not_available: "A vista Kanban não está disponível",
    kanban_view_requires_enum: "A vista Kanban requer uma propriedade de string com valores enum para agrupar entidades em colunas. Adicione uma propriedade enum ao esquema da sua coleção para usar esta vista.",
    no_enum_values_configured: 'Nenhum valor enum configurado para a propriedade "{{property}}"',
    items_need_backfill: "Alguns itens não têm valores de ordem. Inicialize para ativar a reordenação por arrastar e soltar.",
    initialize: "Inicializar",
    confirm_multiple_delete: "Confirmar eliminação múltipla?",
    delete_entity_confirm_title: "Deseja eliminar este/a {{entityName}}?",

    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Gerar Coleção com IA",
    modify_collection_with_ai: "Modificar Coleção com IA",
    describe_collection_to_create: "Descreva a coleção que quer criar.",
    describe_changes_to_make: "Descreva as alterações que quer fazer a esta coleção.",
    ai_placeholder_create: "ex.: Criar uma coleção de produtos com nome, preço, descrição e categoria...",
    ai_placeholder_modify: "ex.: Adicionar um campo de imagem miniatura com armazenamento, tornar o preço obrigatório...",
    ai_assist: "Assistente IA",
    generating: "A gerar...",

    /** Recently extracted strings for collection editor */
    this_is_subcollection_of: "Esta é uma subcoleção de",
    use_existing_paths_database: "Use um dos caminhos existentes na sua base de dados:",
    describe_collection_ai: "Descreva a sua coleção à IA:",
    generate_with_ai: "Gerar com IA",
    create_from_json_config: "Criar a partir de configuração JSON:",
    paste_json_config: "Colar Configuração JSON",
    create_collection_from_file_formats: "Criar uma coleção a partir de um ficheiro (csv, json, xls, xslx...)",
    select_template: "Selecionar um modelo:",
    products: "Produtos",
    collection_products_subtitle: "Uma coleção de produtos com imagens, preços e stock",
    collection_users_subtitle: "Uma coleção de utilizadores com emails, nomes e funções",
    blog_posts: "Publicações de blog",
    collection_blog_posts_subtitle: "Uma coleção de publicações de blog com imagens, autores e conteúdo complexo",
    pages: "Páginas",
    collection_pages_subtitle: "Uma coleção de páginas com imagens, autores e conteúdo complexo",
    continue_from_scratch: "Continuar do zero",

    /** Admin views config */
    cms_users: "Utilizadores do CMS",
    roles_menu: "Funções",
    project_settings: "Definições do projeto",

    // ─── FireCMS Cloud Login ──────────────────────────────────────
    build_admin_panel_in_minutes: "Construa o Seu Painel de Administração Firebase em Minutos",
    go_live_instantly: "Entre em produção instantaneamente:",
    create_production_ready_back_offices: "Crie back-offices prontos para produção",
    without_the_frontend_hassle: "sem o trabalho de frontend.",
    automatic_setup: "Configuração automática",
    from_your_existing_firestore_data: "a partir dos seus dados Firestore existentes.",
    seamless_real_time_firebase_integration: "Integração Firebase em tempo real sem falhas.",
    intuitive_spreadsheet_like_ui: "Interface intuitiva semelhante a uma folha de cálculo",
    your_whole_team_can_use: "que toda a sua equipa pode usar.",
    focus_on_your_app: "Foque-se na sua aplicação,",
    not_the_admin_panel: "não no painel de administração.",
    join_our_newsletter: "Subscreva a nossa newsletter. Sem spam, apenas atualizações importantes!",
    by_signing_in_you_agree_to_our: "Ao iniciar sessão, concorda com os nossos",
    terms_and_conditions: "Termos e Condições",
    and_our: "e a nossa",
    privacy_policy: "Política de privacidade",
    firecms_cloud_google_disclosure: "O uso das APIs Google e a transferência de informações recebidas pela FireCMS Cloud para qualquer outra aplicação seguirá a",
    google_api_services_user_data_policy: "Política de Dados de Utilizador dos Serviços da API Google",
    including_the_limited_use_requirements: "incluindo os requisitos de Uso Limitado.",
    email_password: "Email/palavra-passe",
    sign_in_with_google: "Iniciar sessão com Google",

    // --- Auth error messages ---
    auth_user_not_found: "Utilizador não encontrado",
    auth_wrong_password: "Palavra-passe incorreta. Por favor tente novamente.",
    auth_user_disabled: "Utilizador desativado. Por favor contacte o suporte.",
    auth_account_exists_with_different_credential: "Conta existente com método de início de sessão diferente",
    auth_email_already_in_use: "O email já está em uso",
    auth_google_permissions_required: "Precisa de conceder permissões adicionais para gerir os seus projetos Google Cloud",
    auth_invalid_email_password: "Por favor introduza o email e a palavra-passe",
    auth_enter_email_first: "Por favor introduza primeiro o seu email",
    auth_password_reset_sent: "Email de redefinição de palavra-passe enviado",
    auth_sign_in_account: "Iniciar sessão na sua conta",
    auth_create_new_account: "Criar uma nova conta",
    auth_password: "Palavra-passe",
    auth_reset_password: "Redefinir palavra-passe",
    auth_new_user: "Novo utilizador?",
    auth_have_account: "Já tem uma conta?",
    auth_sign_in: "Iniciar Sessão",
    auth_sign_up: "Registar",

    // --- SaaS Subscriptions ---
    subscriptions: "Subscrições",
    manage_your_subscriptions_in_stripe: "Gerir as suas subscrições no Stripe",
    go_to_your_stripe_portal: "Aceda ao seu portal Stripe para ver o histórico de faturação. Pode também gerir as subscrições associadas ao utilizador com sessão iniciada.",
    your_pro_licenses: "As suas licenças PRO",
    create_new_license: "Criar nova licença",
    create_subscriptions_in_this_section: "Crie subscrições nesta secção apenas para o FireCMS PRO auto-hospedado. Se estiver a usar o FireCMS Cloud, pode atualizar o seu projeto nas definições do projeto.",
    if_you_are_an_agency: "Se for uma agência, pode revender a sua licença aos seus clientes.",
    if_you_have_any_questions: "Se tiver alguma dúvida ou precisar de ajuda, contacte-nos em",
    you_have_not_created_any_pro_licenses: "Ainda não criou nenhuma licença FireCMS PRO",
    archive: "Arquivar",
    licensed_projects_lowercase: "projetos licenciados",
    manage: "Gerir",
    update_payment_method: "Atualizar método de pagamento",
    your_firecms_cloud_projects: "Os seus projetos FireCMS Cloud",
    status_active: "Ativo",
    status_trialing: "Em avaliação",
    status_past_due: "Com pagamento em atraso",
    status_canceled: "Cancelado",
    status_unpaid: "Não pago",
    status_incomplete: "Incompleto",
    status_incomplete_expired: "Incompleto expirado",
    status_unknown: "Desconhecido",

    plan_free: "Não subscrito",
    plan_cloud_plus: "Subscrito",
    plan_pro: "Pro",
    plan_unknown: "Plano Desconhecido",

    auto_setup_collections_button: "Configurar coleções automaticamente",
    auto_setup_collections_title: "Configurar coleções automaticamente?",
    auto_setup_collections_desc: "Isto criará automaticamente configurações de coleção para coleções que <b>NÃO</b> estão já mapeadas",
    this_can_take_a_minute: "Isto pode demorar um ou dois minutos",
    no_collections_found_to_setup: "Nenhuma coleção encontrada para configurar.",
    collections_have_been_setup: "As coleções foram configuradas automaticamente.",
    error_setting_up_collections: "Erro ao configurar coleções automaticamente",

    // --- Home Suggestions ---
    add_your: "Adicione as suas",
    database_collections: "coleções da base de dados",
    to_firecms: "ao FireCMS",
    no_unmapped_collections: "Sem coleções não mapeadas na base de dados",
    query_and_update_with_datatalk: "Consulte e atualize os seus dados em linguagem natural com",

    // --- SaaS Welcome ---
    welcome_to_firecms: "Bem-vindo ao FireCMS Cloud",
    admin_panel_ready_bring_data: "O seu painel de administração está pronto. Vamos importar os seus dados.",
    admin_panel_ready_get_started: "O seu painel de administração está pronto. Veja como começar.",
    auto_detect_collections: "Detetar coleções automaticamente",
    auto_detect_collections_desc: "Deixe a IA analisar a sua base de dados e gerar automaticamente esquemas de coleção.",
    create_a_collection: "Criar uma coleção",
    create_collection_desc: "Defina manualmente a sua primeira coleção do zero usando o editor visual.",
    read_the_docs: "Ler a documentação",
    read_the_docs_desc: "Saiba como personalizar campos, vistas, ações e muito mais.",
    explore_docs: "Explorar documentação",
    want_to_customize_with_code: "Quer personalizar com código? Execute",
    to_scaffold_a_local_project: "para criar um projeto local.",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validação",
    unique: "Único",
    required_message: "Mensagem de campo obrigatório",
    required_tooltip: "Você não poderá salvar esta entidade se este valor não estiver definido",
    unique_tooltip: "Não pode haver múltiplas entidades com o mesmo valor",
    lowercase: "Minúsculas",
    uppercase: "Maiúsculas",
    trim: "Remover espaços",
    exact_length: "Comprimento exato",
    min_length: "Comprimento mín.",
    max_length: "Comprimento máx.",
    matches_regex: "Corresponde a regex",
    not_valid_regexp: "Expressão regular inválida",
    regex_helper: "ex. /^\\d+$/ apenas para dígitos",
    min_value: "Valor mín.",
    max_value: "Valor máx.",
    less_than: "Menor que",
    more_than: "Maior que",
    positive_value: "Valor positivo",
    negative_value: "Valor negativo",
    integer_value: "Valor inteiro",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Expressão regular inválida",
    must_specify_target_collection: "Você deve especificar uma coleção de destino para o campo",
    need_specify_repeat_field: "Você precisa especificar um campo de repetição",
    need_specify_block_properties: "Você precisa especificar as propriedades deste bloco",
    incomplete_condition: "Condição incompleta - por favor selecione um campo",
    field_name: "Nome do campo",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Propriedade de coluna Kanban",
    select_a_property: "Selecionar uma propriedade",
    kanban_property_not_found: "A propriedade \"{{property}}\" não existe ou não é uma propriedade string com enum. Selecione uma propriedade válida ou limpe a seleção.",
    no_enum_string_properties: "Nenhuma propriedade string com enum encontrada. Adicione uma propriedade string com enumValues para usar a visualização Kanban.",
    kanban_column_description: "Selecione uma propriedade string com valores enum para agrupar entidades em colunas",
    create_property: "+ Criar propriedade \"{{property}}\"",
    order_property: "Propriedade de ordem",
    order_property_not_found: "A propriedade \"{{property}}\" não existe ou não é uma propriedade numérica. Selecione uma propriedade válida ou limpe a seleção.",
    no_number_properties: "Nenhuma propriedade numérica encontrada. Adicione uma propriedade numérica para habilitar a ordenação.",
    order_property_description: "Selecione uma propriedade numérica para manter a ordem dos itens",
    display_settings: "Configurações de exibição",
    default_row_size: "Tamanho de linha padrão",
    side_dialog_width: "Largura do diálogo lateral",
    side_dialog_width_description: "Defina opcionalmente a largura (em pixels) do diálogo lateral de entidades. O padrão é 768px",
    inline_editing_enabled: "Os dados podem ser editados diretamente na visualização de tabela",
    inline_editing_disabled: "Os dados só podem ser editados na visualização de formulário",
    inline_editing_description: "Permitir edição de dados diretamente na visualização de tabela, sem abrir a visualização de formulário.",
    include_json_view: "Incluir visualização JSON",
    no_json_view: "Não incluir visualização JSON",
    json_view_description: "Incluir a representação JSON do documento.",
    not_found_suffix: "não encontrado",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Texto",
    editor_text_description: "Comece simplesmente a escrever em texto simples.",
    editor_heading_1: "Título 1",
    editor_heading_1_description: "Título de secção grande.",
    editor_heading_2: "Título 2",
    editor_heading_2_description: "Título de secção médio.",
    editor_heading_3: "Título 3",
    editor_heading_3_description: "Título de secção pequeno.",
    editor_todo_list: "Lista de Tarefas",
    editor_todo_list_description: "Acompanhe tarefas com uma lista de afazeres.",
    editor_bullet_list: "Lista com Marcadores",
    editor_bullet_list_description: "Crie uma lista simples com marcadores.",
    editor_numbered_list: "Lista Numerada",
    editor_numbered_list_description: "Crie uma lista com numeração.",
    editor_quote: "Citação",
    editor_quote_description: "Capture uma citação.",
    editor_code: "Código",
    editor_code_description: "Capture um snippet de código.",
    editor_image: "Imagem",
    editor_image_description: "Carregue uma imagem do seu computador.",
    editor_multiple: "Múltiplos",
    editor_link: "Ligação",
    editor_save: "Guardar",
    editor_cancel: "Cancelar",
    editor_remove_link: "Remover ligação",
    editor_paste_or_type_link: "Cole ou escreva a ligação",
    editor_open_in_new_window: "Abrir numa nova janela",
    editor_bold: "Negrito",
    editor_italic: "Itálico",
    editor_underline: "Sublinhado",
    editor_strikethrough: "Riscado",
    editor_autocomplete: "Preenchimento automático",
    editor_autocomplete_description: "Adicione texto com base no contexto.",

    // ─── Cloud Project Settings ──────────────────────────────────
    settings_subscription_plan: "Plano de subscrição",
    settings_subscribed_to: "Está atualmente subscrito ao",
    settings_no_active_subscription: "Atualmente não existe uma subscrição ativa para este projeto.",
    settings_trial_valid_until: "O seu período de teste é válido até {{date}}.",
    settings_features_intro: "Estas são algumas das funcionalidades que já está a usufruir com o FireCMS Cloud",
    settings_feature_managed_service: "Serviço gerido sempre atualizado",
    settings_feature_local_text_search: "Pesquisa de texto local",
    settings_feature_unlimited_users_roles: "Utilizadores e funções ilimitados",
    settings_feature_theme_logo: "Personalização de tema e logótipo",
    settings_feature_custom_fields_views: "Campos de formulário e vistas personalizadas",
    settings_feature_secondary_databases: "Bases de dados secundárias",
    settings_feature_ai_content: "Geração de conteúdo com IA da OpenAI e Google",
    settings_feature_unlimited_export: "Exportação de dados ilimitada",
    settings_feature_appcheck: "AppCheck",
    settings_heading: "Definições",
    settings_project_name: "Nome do projeto",
    settings_default_language: "Idioma predefinido",
    settings_default_language_caption: "Selecione o idioma base para este projeto. Os utilizadores podem alterar esta preferência nas suas definições pessoais.",
    settings_enable_local_text_search: "Ativar pesquisa de texto local",
    settings_local_text_search_caption: "Ative a pesquisa de texto local para todas as coleções. Isto permitirá pesquisar campos de texto nas suas coleções usando a barra de pesquisa do FireCMS. Note que esta funcionalidade pode resultar num maior número de leituras, pois todos os campos de texto das suas coleções serão indexados.",
    settings_doc_history_all_collections: "Histórico de documentos ativado para todas as coleções",
    settings_doc_history_caption: "Quando ativado, todas as coleções terão o histórico ativado por predefinição. Pode alterar esta definição em cada coleção. O histórico será guardado na subcoleção __history de cada documento.",
    settings_theme: "Tema",
    settings_primary_color: "Cor primária",
    settings_secondary_color: "Cor secundária",
    settings_sample_theme_components: "Exemplos de componentes do tema",
    settings_drag_drop_logo: "Arraste e solte o seu logótipo aqui",
    settings_create_subscription: "Criar uma subscrição",
    settings_stripe_disclaimer: "Será redirecionado para o Stripe para completar a sua subscrição. A faturação é mensal, com base no número máximo de utilizadores do mês. Cancele a qualquer momento – já pagou o período de faturação atual, pelo que não serão aplicados custos adicionais após o cancelamento.",
    settings_subscription_is: "A subscrição está",
    settings_next_payment_on: "O próximo pagamento é a {{date}}.",
    settings_seats_count: "Tem",
    settings_seat: "lugar",
    settings_seats: "lugares",
    settings_per_seat: "a {{price}}/lugar/{{interval}}",
    settings_current_price: "O preço atual é",
    settings_per_user_usage: "por utilizador (baseado em utilização).",
    settings_cancelled_active_until: "Esta subscrição foi cancelada e estará ativa até {{date}}.",
    settings_no_additional_charges: "Não serão aplicados custos adicionais após o cancelamento.",
    settings_manage_subscription: "Gerir subscrição",
    settings_security_rules: "Regras de segurança",
    settings_security_rules_description: "O FireCMS utiliza as regras de segurança do Firebase para restringir o acesso aos dados. Ao criar um novo utilizador através do FireCMS, o atributo personalizado fireCMSUser é adicionado ao utilizador no projeto cliente. Ao adicionar as seguintes regras de segurança ao seu projeto, garante que os utilizadores do FireCMS possam aceder aos dados através do FireCMS.",
    settings_security_rules_add_domain: "Lembre-se de adicionar o domínio {{domain}} aos domínios permitidos do seu fornecedor",
    settings_security_rules_caption: "Estas regras restringem o acesso aos dados apenas aos utilizadores do FireCMS, mas não aplicam as permissões ao nível da base de dados. As permissões são aplicadas no frontend, o que funciona bem para a maioria dos projetos. Se precisar de aplicar as permissões ao nível da base de dados, pode modificar estas regras de segurança. As funções atribuídas a um utilizador são definidas como atributos personalizados no token de autenticação do Firebase, pelo que pode utilizá-las nas suas regras de segurança.",
    settings_appcheck: "AppCheck",
    settings_appcheck_description: "Pode ativar o AppCheck para proteger os seus serviços Firebase contra abusos. Consulte a documentação do Firebase para configuração. Quando tiver um fornecedor configurado, pode ativá-lo aqui. Terá de fornecer um segredo nas definições do seu projeto Firebase e uma chave de site na configuração do FireCMS.",
    settings_appcheck_add_domain: "Lembre-se de adicionar o domínio {{domain}} aos domínios permitidos do seu fornecedor",
    settings_appcheck_enable: "Ativar AppCheck",
    settings_appcheck_site_key: "Chave de site",
    settings_appcheck_update: "Atualizar AppCheck",
    settings_appcheck_refresh_note: "Poderá ter de atualizar a página após guardar para ver as alterações.",
    settings_appcheck_updated: "AppCheck atualizado",
    settings_appcheck_error: "Erro ao atualizar o AppCheck",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Ativar pesquisa de texto",
    text_search_local_not_recommended: "A pesquisa de texto local não é recomendada para coleções grandes.",
    text_search_local_fetch_warning: "Note que ativar a pesquisa de texto local requer descarregar todos os documentos da sua coleção e armazená-los no navegador. Isto pode ser ineficiente para coleções grandes e gerar custos adicionais.",
    text_search_external_suggestion: "Para coleções maiores, recomendamos usar um motor de pesquisa externo como Algolia ou Elastic Search e atribuir um delegado de pesquisa à sua configuração.",
    text_search_local_description: "A pesquisa de texto local é a forma mais simples de ativar a pesquisa de texto na sua coleção. Carrega todos os documentos da coleção no navegador e efetua a pesquisa localmente. É a opção recomendada para coleções pequenas.",
    text_search_own_implementation: "Implementou o seu próprio controlador de pesquisa de texto. Pode ativar a pesquisa de texto para a sua coleção.",
    text_search_enable_for_collection: "Ativar para esta coleção",
    text_search_enable_for_project: "Ativar para o projeto",
    text_search_enabled_snackbar: "Pesquisa de texto local ativada"
};
